import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Icon, IwocaLogo } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import commonMessages from '@src/containers/Containers.messages';
import { redirectToURL } from '@src/helpers/redirection';
import LoadingPlaceholder from '@src/loadingPlaceholder/LoadingPlaceholder';
import { RootState } from '@src/reducers';
import { getAmplitudeDefaultEventProperties } from '@src/tracking/amplitudeEvents';

import styles from './NewRequestLayout.module.css';
import SidePanel from './SidePanel/SidePanel';

type TProps = {
    children: React.ReactNode;
};

const mapStateToProps = (state: RootState) => ({
    isApplicationStateLoading: state.fetched.application.loading
});

const handleBackButton = () => {
    tracking.ampli.backCtaClicked({
        ...getAmplitudeDefaultEventProperties(),
        'CTA text': 'Back',
        pageName: 'Apply now'
    });

    redirectToURL('https://www.iwoca.co.uk');
};

const NewRequestLayout = ({
    children,
    isApplicationStateLoading
}: TProps & ReturnType<typeof mapStateToProps>) => {
    if (isApplicationStateLoading) {
        // Re-use loading placeholder to make UX loading state seemless.
        // TODO: Review the use of placeholder html in index.html files
        return <div data-testid="layout-loader">{LoadingPlaceholder()}</div>;
    }

    return (
        <>
            <div className={styles.container}>
                <section className={styles.mainPanelContainer}>
                    <div className={styles.mainPanelContent}>
                        <div className={styles.logoContainer}>
                            <Button
                                className={styles.backButton}
                                variant="tertiary"
                                onClick={handleBackButton}>
                                <Icon
                                    icon="angleLeft"
                                    className={styles.backIcon}
                                />
                                <FormattedMessage {...commonMessages.back} />
                            </Button>
                            <div
                                data-testid="iwoca-logo"
                                className={styles.logo}>
                                <IwocaLogo />
                            </div>
                        </div>
                        {children}
                    </div>
                </section>
                <aside className={styles.sidePanel}>
                    <SidePanel />
                </aside>
            </div>
        </>
    );
};

export default connect(mapStateToProps)(NewRequestLayout);
